/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1Icon24Solid = forwardRef('People1Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 13a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" }),
        React.createElement("path", { d: "M2.179 20.01C3.264 14.394 9.015 14 12 14c2.985 0 8.736.395 9.821 6.01.21 1.084-.716 1.99-1.821 1.99H4c-1.105 0-2.03-.906-1.821-1.99Z" })));
});
